import { Skeleton } from "~/components/ui/skeleton";

/**
 * Skeleton for the feature-content-module section (c_moduleTopFeatureContent,
 * c_module1/2/3FeatureContent). These are raw HTML blobs from BM; the typical
 * production visual is a wide content block per module. Mirrors product-details.tsx
 * L708-765 wrapper.
 */
export const FeatureContentModulesSkeleton = ({
  modules = 1,
}: {
  modules?: number;
} = {}) => {
  return (
    <section
      className="feature-content-modules-skeleton mt-8 w-full space-y-6"
      aria-label="Feature content loading"
    >
      {Array.from({ length: modules }).map((_, i) => (
        <div key={i} className="space-y-2">
          <Skeleton className="h-5 w-1/3" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
        </div>
      ))}
    </section>
  );
};
